import React, { useState } from 'react';
import { AppProvider } from './context/AppContext';
import Login from './pages/Login';
import POS from './pages/POS';
import Admin from './pages/Admin';
import History from './pages/History';
import Members from './pages/Members';
import Receiving from './pages/Receiving';
import TaxReport from './pages/TaxReport';
import Cigars from './pages/Cigars';
import Marketing from './pages/Marketing';
import GlobalNav from './components/GlobalNav';
import { useResponsive } from './hooks/useResponsive';
import { API_BASE_URL } from './utils/api';

const App = () => {
  const [staff, setStaff] = useState(null);
  const [view, setView] = useState('pos');
  const { isMobile } = useResponsive();

  const handleLogin  = (s) => { setStaff(s); };
  const handleLogout = () => { setStaff(null); setView('pos'); };

  const nav = {
    onPos:       () => setView('pos'),
    onHistory:   () => setView('history'),
    onMembers:   () => setView('members'),
    onReceiving: () => setView('receiving'),
    onReports:   () => setView('taxreport'),
    onAdmin:     () => setView('admin'),
    onCigars:    () => setView('cigars'),
    onMarketing: () => setView('marketing'),
    onLogout:    handleLogout,
  };

  const isSecondaryPage = staff && view !== 'pos';

  return (
    <AppProvider>
      <div style={{ minHeight: '100dvh', background: '#0D0D0D', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden' }}>
        {!staff && <Login onLogin={handleLogin} />}

        {staff && view === 'pos' && (
          <>
            <POS
              staff={staff}
              onLogout={handleLogout}
              onAdmin={nav.onAdmin}
              onHistory={nav.onHistory}
              onMembers={nav.onMembers}
              onReceiving={nav.onReceiving}
              onTaxReport={nav.onReports}
              onMarketing={nav.onMarketing}
              onCigars={nav.onCigars}
            />
            {isMobile && (
              <div style={{ position: 'fixed', bottom: 'calc(56px + env(safe-area-inset-bottom) + 2px)', left: 0, right: 0, textAlign: 'center', zIndex: 890, pointerEvents: 'none', lineHeight: 0 }}>
                <img src={`${API_BASE_URL}/images/puroai-logo.png`} alt="Puro POS" style={{ height: 34, width: 'auto', opacity: 0.5 }} />
              </div>
            )}
            {!isMobile && (
              <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, textAlign: 'center', background: '#000', zIndex: 9999, lineHeight: 0 }}>
                <img src={`${API_BASE_URL}/images/puroai-logo.png`} alt="Powered by Puro POS" style={{ height: 80, width: 'auto', opacity: 0.97 }} />
              </div>
            )}
          </>
        )}

        {isSecondaryPage && (
          <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh', overflow: 'hidden' }}>
            <GlobalNav staff={staff} currentView={view} nav={nav} />
            <div style={{
              flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch',
              paddingBottom: isMobile ? 'calc(56px + env(safe-area-inset-bottom) + 44px)' : 80,
            }}>
              {view === 'admin'     && <Admin     staff={staff} onBack={nav.onPos} hideHeader />}
              {view === 'history'   && <History   staff={staff} onBack={nav.onPos} hideHeader />}
              {view === 'receiving' && <Receiving staff={staff} onBack={nav.onPos} hideHeader />}
              {view === 'members'   && <Members   staff={staff} onBack={nav.onPos} hideHeader />}
              {view === 'taxreport' && <TaxReport staff={staff} onBack={nav.onPos} hideHeader />}
              {view === 'cigars'    && <Cigars    staff={staff} onBack={nav.onPos} hideHeader />}
              {view === 'marketing' && <Marketing staff={staff} onBack={nav.onPos} hideHeader />}
            </div>
          </div>
        )}
      </div>
    </AppProvider>
  );
};

export default App;
